module.exports = __webpack_public_path__ + "img/sign-out.8a7e54b9.svg";